import { render, staticRenderFns } from "./ChangeModel.vue?vue&type=template&id=4544dc6e&scoped=true&"
import script from "./ChangeModel.vue?vue&type=script&lang=js&"
export * from "./ChangeModel.vue?vue&type=script&lang=js&"
import style0 from "./ChangeModel.vue?vue&type=style&index=0&id=4544dc6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4544dc6e",
  null
  
)

export default component.exports